/**
 * The Diolo stamp — the D of the wordmark (Hayden: "the stamp is the D
 * from the Diolo"). The exact glyph outline from Hayden's logo export
 * (public/brand/diolo-logo.svg, 2026-09-06 — A4 Speed Bold), replacing a
 * potrace of an older wordmark. Fills with currentColor so it takes the
 * tier accent.
 *
 *   solid   — a stamp that has been earned
 *   faint   — a slot still to earn (same shape, quiet)
 *   outline — hairline D, for pending / unreached markers
 */
export const DIOLO_D_VIEWBOX = "-19.64 -219.95 311.33 220.45";
export const DIOLO_D_PATH =
  "M 60.625 -219.453125 L -19.140625 0 L 183.296875 0 C 194.878906 0 205.335938 -3.25 214.671875 -9.75 C 224.003906 -16.25 230.679688 -25.050781 234.703125 -36.15625 L 287.890625 -182.578125 C 291.191406 -191.566406 290.125 -199.957031 284.6875 -207.75 C 279.257812 -215.550781 271.816406 -219.453125 262.359375 -219.453125 Z M 123.03125 -164.5 L 199.25 -164.5 L 159.1875 -54.953125 L 82.96875 -54.953125 Z M 123.03125 -164.5";

interface DioloStampProps {
  variant?: "solid" | "faint" | "outline";
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

export function DioloStamp({ variant = "solid", className = "h-4 w-auto", style, title }: DioloStampProps) {
  return (
    <svg
      viewBox={DIOLO_D_VIEWBOX}
      className={className}
      style={style}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
      focusable="false"
    >
      {title && <title>{title}</title>}
      {variant === "outline" ? (
        <path d={DIOLO_D_PATH} fill="none" stroke="currentColor" strokeWidth={1.4} vectorEffect="non-scaling-stroke" strokeLinejoin="round" />
      ) : (
        <path d={DIOLO_D_PATH} fill="currentColor" opacity={variant === "faint" ? 0.28 : 1} />
      )}
    </svg>
  );
}
